export const pageGridSizeAccordingToLocation = (location, routePath) => {
  return (
    location.pathname !== routePath.LOGIN &&
    location.pathname !== routePath.LANDINGPAGE &&
    location.pathname !== routePath.WHATISELEGANTPRIME &&
    location.pathname !== routePath.LANDINGPAGERESTORENT &&
    location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    location.pathname !== routePath.LANDINGPAGEFRANCHISE &&
    location.pathname !== routePath.COUNTERSELLBILLING &&
    location.pathname !== routePath.UPDATEBILLS
  );
};

export const handleHeaderRenderingAccordingTopages = (routePath, location) => {
  return (
    location.pathname !== routePath.LANDINGPAGE ||
    location.pathname !== routePath.WHATISELEGANTPRIME ||
    location.pathname !== routePath.SERVICESLIST
  );
};

export const handleHeaderLandingRenderingAccordingTopages = (
  routePath,
  location,
) => {
  return (
    location.pathname === routePath.LOGIN ||
    location.pathname === routePath.LANDINGPAGE ||
    location.pathname !== routePath.WHATISELEGANTPRIME ||
    location.pathname === routePath.LANDINGPAGERESTORENT ||
    location.pathname === routePath.LANDINGPAGECOUNTERTOKEN ||
    location.pathname === routePath.LANDINGPAGEMONTHLYBILL ||
    location.pathname === routePath.LANDINGPAGEFRANCHISE ||
    location.pathname == routePath.SERVICESLIST
  );
};
export const handleMobileHeaderRederingAccordingToPages = (
  location,
  routePath,
) => {
  return (
    location.pathname !== routePath.LOGIN &&
    location.pathname !== routePath.LANDINGPAGE &&
    location.pathname !== routePath.WHATISELEGANTPRIME &&
    location.pathname !== routePath.LANDINGPAGERESTORENT &&
    location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    location.pathname !== routePath.LANDINGPAGEFRANCHISE &&
    location.pathname !== routePath.COUNTERSELLBILLING &&
    location.pathname !== routePath.UPDATEBILLS
  );
};

export const halfSideBarRenderingAccordingToPages = (location, routePath) => {
  // console.log(
  //   "pathname ==",
  //   location.pathname.split("/")[location.pathname.split("/").length - 2],
  //   " ",
  //   routePath.APPLYJOB
  // );
  if (
    (location.pathname.split("/").length >= 3 &&
      location.pathname.split("/")[location.pathname.split("/").length - 2] ==
        "apply") ||
    location.pathname.split("/")[location.pathname.split("/").length - 2] ==
      "coursedetails" ||
    location.pathname.split("/")[location.pathname.split("/").length - 2] ==
      "instituteInfo" ||
    location.pathname.split("/")[location.pathname.split("/").length - 2] ==
      "franchiseDetails" ||
    location.pathname.split("/")[location.pathname.split("/").length - 2] ==
      "consultantDetails" ||
    location.pathname.split("/")[location.pathname.split("/").length - 2] ==
      "furnatureDetials"
  ) {
    return false;
  }
  return (
    location.pathname !== routePath.LOGIN &&
    location.pathname !== routePath.LANDINGPAGE &&
    location.pathname !== routePath.LANDINGPAGERESTORENT &&
    location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    location.pathname !== routePath.LANDINGPAGEFRANCHISE &&
    location.pathname !== routePath.COUNTERSELLBILLING &&
    location.pathname !== routePath.UPDATEBILLS &&
    location.pathname !== routePath.WHATISELEGANTPRIME &&
    location.pathname != routePath.SERVICESLIST &&
    location.pathname !== routePath.JOBS &&
    location.pathname != routePath.SALON &&
    location.pathname != routePath.DETAILS &&
    location.pathname != routePath.PROFILEPAGE &&
    location.pathname != routePath.SERVICES &&
    location.pathname != routePath.FAV &&
    location.pathname !== routePath.ASSISTANTLOGIN &&
    location.pathname !== routePath.COMPANYUSELOGIN &&
    location.pathname !== routePath.MYJOBPROFILE &&
    location.pathname !== routePath.EDITPROFILE &&
    location.pathname !== routePath.JOBSLIST &&
    location.pathname !== routePath.COURSES &&
    location.pathname !== routePath.COURSEDETAILS &&
    location.pathname !== routePath.INSTITUTEINFO &&
    location.pathname !== routePath.REGISTRATION &&
    location.pathname !== routePath.OTP &&
    location.pathname !== routePath.FRANCHISE &&
    location.pathname !== routePath.CUSTOMERLOGIN &&
    location.pathname !== routePath.WHITELABLESLIST &&
    location.pathname !== routePath.CONSULTANTSLIST &&
    location.pathname !== routePath.FURNITURELIST &&
    location.pathname !== routePath.favroutesPages

    // location.pathname &&
    // location.pathname.split("/").length > 2 &&
    // location.pathname.split("/").length-2 !== routePath.APPLYJOB
  );
};

export const footerRenderingAccordingToPages = (location, routePath) => {
  return (
    location.pathname !== routePath.ROOT &&
    location.pathname !== routePath.LOGIN &&
    location.pathname !== routePath.LANDINGPAGE &&
    location.pathname !== routePath.WHATISELEGANTPRIME &&
    location.pathname !== routePath.LANDINGPAGERESTORENT &&
    location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    location.pathname !== routePath.LANDINGPAGEFRANCHISE &&
    location.pathname !== routePath.JOBS
  );
};

export const ensureAuthenticatedUserOrRedirectToLandingPage = (
  token,
  location,
  routePath,
) => {
  return (
    token === null &&
    location.pathname !== "/login" &&
    location.pathname !== routePath.WHATISELEGANTPRIME &&
    location.pathname !== routePath.LANDINGPAGERESTORENT &&
    location.pathname !== routePath.LANDINGPAGECOUNTERTOKEN &&
    location.pathname !== routePath.LANDINGPAGEMONTHLYBILL &&
    location.pathname !== routePath.LANDINGPAGEFRANCHISE
  );
};
